import React from 'react';
import { cn } from '../../utils/cn';

const BentoGrid = ({ children, className, ...props }) => {
  return (
    <div
      className={cn(
        "grid w-full grid-cols-1 md:grid-cols-4 gap-6",
        "grid-rows-[280px_280px] md:grid-rows-[280px_280px]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default BentoGrid;

